/**
 * Secret variable values out of the tracked mirror (found 02.10.2026 by the
 * real end-to-end run against Gitea): the nested mirror layout
 * (workspaceMirror.js — every workspace not on the sync engine) wrote global,
 * workspace and environment variables marked `secret` WITH their values into
 * tracked YAML, so a sync pushed them to the remote. Only folder variables
 * were blanked.
 *
 * Same rule as the flat layout (yamlWorkspace/serialize.js): the tracked row
 * keeps its key and `secret: true` with an empty value; the value lives in an
 * untracked `*.local.yaml` sidecar next to it (git-ignored by Apiboo's
 * .gitignore block) and is merged back when the mirror is read.
 */

/** @returns {{ tracked: object[], local: Array<{key, value}> }} */
export function splitSecrets(rows = []) {
  const local = [];
  const tracked = rows.map((row) => {
    if (!row?.secret) return row;
    if (row.value !== undefined && row.value !== '') local.push({ key: row.key, value: row.value });
    return { ...row, value: '' };
  });
  return { tracked, local };
}

/** Put sidecar values back into the tracked rows (by key, secret rows only). */
export function mergeSecrets(rows = [], local = []) {
  if (!local?.length) return rows;
  const byKey = new Map(local.filter((r) => r && r.key != null).map((r) => [String(r.key), r.value]));
  return rows.map((row) => (row?.secret && byKey.has(String(row.key)) ? { ...row, value: byKey.get(String(row.key)) } : row));
}

/** `environments/staging.yaml` → `environments/staging.local.yaml` */
export const sidecarOf = (rel) => rel.replace(/\.yaml$/, '.local.yaml');
export const isSidecar = (name) => /\.local\.yaml$/.test(String(name || ''));
